// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DevelopmentBidPackagesPageMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DevelopmentBidPackagesPageMetadataQuery = { __typename?: 'Query', costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }> };


export const DevelopmentBidPackagesPageMetadataDocument = gql`
    query DevelopmentBidPackagesPageMetadata {
  costCodes {
    ...Named
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useDevelopmentBidPackagesPageMetadataQuery__
 *
 * To run a query within a React component, call `useDevelopmentBidPackagesPageMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentBidPackagesPageMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentBidPackagesPageMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useDevelopmentBidPackagesPageMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DevelopmentBidPackagesPageMetadataQuery, DevelopmentBidPackagesPageMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentBidPackagesPageMetadataQuery, DevelopmentBidPackagesPageMetadataQueryVariables>(DevelopmentBidPackagesPageMetadataDocument, options);
      }
export function useDevelopmentBidPackagesPageMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentBidPackagesPageMetadataQuery, DevelopmentBidPackagesPageMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentBidPackagesPageMetadataQuery, DevelopmentBidPackagesPageMetadataQueryVariables>(DevelopmentBidPackagesPageMetadataDocument, options);
        }
export function useDevelopmentBidPackagesPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentBidPackagesPageMetadataQuery, DevelopmentBidPackagesPageMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentBidPackagesPageMetadataQuery, DevelopmentBidPackagesPageMetadataQueryVariables>(DevelopmentBidPackagesPageMetadataDocument, options);
        }
export type DevelopmentBidPackagesPageMetadataQueryHookResult = ReturnType<typeof useDevelopmentBidPackagesPageMetadataQuery>;
export type DevelopmentBidPackagesPageMetadataLazyQueryHookResult = ReturnType<typeof useDevelopmentBidPackagesPageMetadataLazyQuery>;
export type DevelopmentBidPackagesPageMetadataSuspenseQueryHookResult = ReturnType<typeof useDevelopmentBidPackagesPageMetadataSuspenseQuery>;
export type DevelopmentBidPackagesPageMetadataQueryResult = Apollo.QueryResult<DevelopmentBidPackagesPageMetadataQuery, DevelopmentBidPackagesPageMetadataQueryVariables>;